<!--团检体检报告 点击字体放大-->
<template>
  <div class="">
    <div class="m-tab-box">
      <ul class="m-tab" ref="tabBox">
        <li v-for="(item,index) in tabItems" :key="index" :class="{'m-tab-active': index === tabIndex}"
            @click="getDist(tabItems.length,index,item)">
          {{item.name}}
        </li>
      </ul>
      <p ref="tabStrip" :style="{width: width + 'px'}"></p>
    </div>
  </div>
</template>

<script>
import jumper from '@/assets/scripts/jumper/index'

export default {
  props: {
    tabItems: {
      type: Array
    },
    width: {
      type: [String, Number],
      default: '50'
    }
  },
  data () {
    return {
      tabIndex: 0,
      tabPaths: []
    }
  },
  created () {
    this.tabItems.forEach((obj) => {
      this.tabPaths.push(obj.path)
    })
  },
  methods: {
    getDist (num, index, item) {
      this.tabIndex = index
      // tab 底部条动画
      let width = this.$refs.tabBox.getBoundingClientRect().width
      let a = width / num
      a = a * (index + 1) - a / 2 - this.width / 2
      this.$refs.tabStrip.style.transform = `translateX(${a}px)`
      this.$refs.tabStrip.style.transitionDuration = `0.2s`
      if (item) {
        item && jumper.jumpByElementId(item.id)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getDist(this.tabItems.length, 0)
    })
    for (let i = 0; i < this.tabPaths.length; i++) {
      if (this.$route.path === this.tabPaths[i]) {
        this.active = i
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
.m-tab-box {
  position: relative;
  width: 100%;
  .m-tab {
    display: flex;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    background-color: #ffffff;
    > li {
      flex: 1;
      color: #999999;
    }
  }
  > p {
    position: absolute;
    bottom: 1px;
    width: 30px;
    height: 2px;
    z-index: 1;
    background-color: $assertive;
  }
}

.m-tab-active {
  font-size: 18px;
  font-weight: bold;
  color: #000000 !important;
}
</style>
